import { Validator } from '../util/validator';

export const DateFormatter = {
  MONTH_NAMES: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October',
    'November', 'December'],
  MONTH_ABBRS: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],

  monthName(zeroBasedMonth: number | Date, options: { abbr: boolean } = { abbr: false }): string {
    const i = Validator.isDateObject(zeroBasedMonth) ? (zeroBasedMonth as Date).getMonth() : zeroBasedMonth as number;

    return options.abbr ? this.MONTH_ABBRS[i] : this.MONTH_NAMES[i];
  },

  diff(start: Date, end: Date): string {
    const diff = end.getTime() - start.getTime();
    const oneSec = 1000;
    const ms = diff % oneSec;

    if (diff < oneSec) {
      return ms + ' ms';
    }

    const oneMin = 60 * oneSec;
    const s = Math.floor(( diff % oneMin ) / oneSec);

    if (s < 60) {
      return `${s}.${ms} sec`;
    }

    const oneHour = 60 * oneMin;
    const m = Math.floor(( diff % oneHour ) / oneMin);

    return `${m}:${s}.${ms} min`;
  }
};



// WEBPACK FOOTER //
// ./src/gs-core/common/convert/DateFormatter.ts